import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Chip from "@mui/material/Chip";
import Drawer from "@mui/material/Drawer";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";

import { DateSelector } from "/imports/ui/components/shared";
import { TimeSlotCard } from "/imports/ui/components/booking";

function SlotComposerSheet({
  open,
  onClose,
  noun,
  isCourt,
  composeLocationIds,
  composeLocationId,
  setComposeLocationId,
  locationNameById,
  sheetDate,
  setSheetDate,
  today,
  maxDate,
  dayTrainers,
  sheetTrainerId,
  setSheetTrainerId,
  slotsLoading,
  groups,
  pickedTimes,
  onAddPick
}) {
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderTopLeftRadius: 20, borderTopRightRadius: 20, maxHeight: "75vh", px: 2.5, pt: 2, pb: 3 } }}
    >
      <Box sx={{ width: "2.5rem", height: "0.25rem", borderRadius: 2, bgcolor: "divider", mx: "auto", mb: 2 }} />
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
        <Typography sx={{ fontSize: "1.05rem", fontWeight: 700 }}>Pick a {noun}</Typography>
        <IconButton size="small" onClick={onClose} aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      {composeLocationIds.length > 1 && (
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 1.5 }}>
          {composeLocationIds.map((id) => (
            <Chip
              key={id}
              size="small"
              clickable
              label={locationNameById.get(id) || "Location"}
              color={composeLocationId === id ? "primary" : "default"}
              variant={composeLocationId === id ? "filled" : "outlined"}
              onClick={() => setComposeLocationId(id)}
            />
          ))}
        </Box>
      )}

      <Box sx={{ mb: 1.5 }}>
        <DateSelector value={sheetDate} onChange={setSheetDate} minDate={today.toISODate()} maxDate={maxDate} compact />
      </Box>

      {!isCourt && dayTrainers.length > 0 && (
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 1.5 }}>
          <Chip
            size="small"
            clickable
            label="Any trainer"
            color={!sheetTrainerId ? "primary" : "default"}
            variant={!sheetTrainerId ? "filled" : "outlined"}
            onClick={() => setSheetTrainerId(null)}
          />
          {dayTrainers.map((t) => (
            <Chip
              key={t._id}
              size="small"
              clickable
              label={t.name}
              color={sheetTrainerId === t._id ? "primary" : "default"}
              variant={sheetTrainerId === t._id ? "filled" : "outlined"}
              onClick={() => setSheetTrainerId(t._id)}
            />
          ))}
        </Box>
      )}

      <Box sx={{ overflowY: "auto" }}>
        {slotsLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress size="1.5rem" />
          </Box>
        ) : groups.length === 0 ? (
          <Typography variant="body2" color="textSecondary" sx={{ py: 3, textAlign: "center" }}>
            No free times this day — try another date{isCourt ? "" : " or trainer"}.
          </Typography>
        ) : (
          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1, pb: 1 }}>
            {groups.map((group) => (
              <TimeSlotCard key={group.time} time={group.time} hidePrice disabled={pickedTimes.has(group.time)} onClick={() => onAddPick(group)} />
            ))}
          </Box>
        )}
      </Box>
    </Drawer>
  );
}

export default SlotComposerSheet;
